import React, { useEffect, useState, useContext, memo } from "react";
import Headline from "./Headline";
import List from "./List";
import { Data } from "../App";

// ランク内でシリーズ単位に分割
const Series = memo(({ data }) => {
  const { detailList } = useContext(Data);
  const [seriesList, setSeriesList] = useState([]);

  // シリーズの一覧（重複無し）を取得
  useEffect(() => {
    const seriesAll = data.map((elm) => {
      return elm.series;
    });
    const seriesInRank = [...new Set(seriesAll)];
    if (JSON.stringify(seriesInRank) !== JSON.stringify(seriesList)) {
      setSeriesList(seriesInRank);
    }
  }, [data, seriesList]);

  // シリーズごとに分割した生地リストを表示
  return (
    <>
      {seriesList.map((series, i) => {
        const seriesData = data.filter((item) => item.series === series);
        const seriesDetail = detailList.find((item) => item.series === series);
        if (seriesData.length > 0) {
          return (
            <div className="series_container" key={i}>
              <Headline data={seriesDetail} />
              <List data={seriesData} />
            </div>
          );
        }
      })}
    </>
  );
});

export default Series;
